import { createContext, PropsWithChildren, useContext } from "react";

interface MainContentContainerProps extends PropsWithChildren {}

const MainContext = createContext<boolean>(true);

export const MainContentContainer = ({
  children,
}: MainContentContainerProps) => {
  return (
    <MainContext.Provider value={true}>
      <div className="flex flex-col max-h-[calc(100svh-5rem)] w-full overflow-hidden overscroll-contain">
        {children}
      </div>
    </MainContext.Provider>
  );
};

export const useMainContext = () => {
  const context = useContext(MainContext);
  if (!context) {
    throw new Error("useMainContext must be used within MainContentContainer");
  }
  return context;
};
